export const PRIMARY_MAIN = "#F39747";
